module.exports = __webpack_public_path__ + "img/home21.1713174e.jpg";